import React from 'react';
import PropTypes from 'prop-types';

import { Heading, sluggify } from 'sarsaparilla';

export default function AnchorPageSection({
    children,
    heading,
    headingLevel = 2,
    headingAppearance = 'h5',
}) {
    const id = sluggify(heading);

    return (
        <section data-component="AnchorPageSection" id={`${id}-section`}>
            <div className="heading-spacer">
                <Heading
                    data-shared-anchor-page-section-heading
                    tabIndex="-1"
                    className="mb-2"
                    id={id}
                    headingLevel={headingLevel}
                    appearance={headingAppearance}
                >
                    {heading}
                </Heading>
            </div>

            {children}
        </section>
    );
}

AnchorPageSection.propTypes = {
    heading: PropTypes.string,
    children: PropTypes.node,
    headingLevel: PropTypes.number,
    headingAppearance: PropTypes.string,
};
